var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-menu",
        {
          staticClass: "el-menu-demo",
          attrs: { "default-active": _vm.activeIndex, mode: "horizontal" },
          on: {
            select: function($event) {
              return _vm.handover($event)
            }
          }
        },
        [
          _c("el-menu-item", { attrs: { index: "rewardList" } }, [
            _vm._v("奖励分组")
          ]),
          _c("el-menu-item", { attrs: { index: "rewardRule" } }, [
            _vm._v("奖励规则")
          ])
        ],
        1
      ),
      _c("rewardList", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeIndex == "rewardList",
            expression: "activeIndex == 'rewardList'"
          }
        ],
        ref: "rewardList"
      }),
      _c("rewardRule", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeIndex == "rewardRule",
            expression: "activeIndex == 'rewardRule'"
          }
        ],
        ref: "rewardRule"
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }